// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { useBankUploadData } from '@client/banks/providers/bank-upload-provider';
import { useStepsData } from '@shared/ui-kit/hooks/use-steps';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import { cloneElement, isValidElement, useCallback, useMemo } from 'react';

const useConnectExternal = () => {
  const { externalConnectContent } = useBankUploadData();
  const { navigate } = useStepsData();

  const onBack = useCallback(() => {
    navigate('flow-select');
  }, [navigate]);

  const content = useMemo(() => {
    if (!isValidElement(externalConnectContent)) {
      return externalConnectContent;
    }

    return cloneElement(externalConnectContent, { onBack } as {
      onBack: () => void;
    });
  }, [externalConnectContent, onBack]);

  return { content };
};

export const ConnectExternal = defineComponent({
  displayName: 'ConnectExternal',
  useSetup: useConnectExternal,
  View: ({ content }) => (
    <div
      className="flex h-full min-h-0 flex-col overflow-hidden"
      data-testid="bank-upload-connect-external"
    >
      {content}
    </div>
  ),
});
